import { render } from "./CustomsDeclarationSectionOne.vue?vue&type=template&id=4b5ccd32&scoped=true"
import script from "./CustomsDeclarationSectionOne.vue?vue&type=script&lang=js"
export * from "./CustomsDeclarationSectionOne.vue?vue&type=script&lang=js"

import "./CustomsDeclarationSectionOne.vue?vue&type=style&index=0&id=4b5ccd32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b5ccd32"]])

export default __exports__